import React, { useEffect, useState } from 'react'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import isFunction from 'lodash/isFunction'
import { PageSizeDropdown } from 'src/components/Reusable/paginate/PageSizeDropdown'
import { FlexRow } from '../Flex'
import {
  NextIcon,
  PrevNext,
  PlainButton,
  PaginateContainer,
} from '../prevNext/prevNext.styles'
import { getItemRange } from './paginate.helpers'

export type PaginateButtonsProps = {
  totalItems: number
  pageSize: number
  useCustomPagesize?: boolean
}

export type PaginateButtonsGroupProps = PaginateButtonsProps & {
  currentPage: number
  onPrevClick: (() => void) | null
  onNextClick: (() => void) | null
}

export const PaginateButtonsGroup = ({
  totalItems,
  pageSize,
  currentPage,
  onPrevClick,
  onNextClick,
  useCustomPagesize = true,
}: PaginateButtonsGroupProps): JSX.Element => {
  const [itemRange, setItemRange] = useState<string>('')
  const [total, setTotal] = useState<number>(0)

  useEffect(() => {
    if (!totalItems) return
    if (totalItems !== total) {
      setTotal(totalItems)
    }
    const range = getItemRange(currentPage, pageSize, totalItems)
    if (range !== itemRange) {
      setItemRange(range)
    }
  }, [currentPage, pageSize, totalItems, total, itemRange])

  if (totalItems <= 10) return <></>

  return (
    <PaginateContainer>
      <PrevNext>
        {itemRange} of {total}
      </PrevNext>
      {useCustomPagesize && <PageSizeDropdown />}
      {totalItems > pageSize && (
        <FlexRow gap={32}>
          <PlainButton
            disabled={!isFunction(onPrevClick)}
            onClick={onPrevClick || (() => undefined)}
          >
            <NextIcon
              icon={faChevronLeft}
              disabled={!isFunction(onPrevClick)}
            />
          </PlainButton>
          <PlainButton
            disabled={!isFunction(onNextClick)}
            onClick={onNextClick || (() => undefined)}
          >
            <NextIcon
              icon={faChevronRight}
              disabled={!isFunction(onNextClick)}
            />
          </PlainButton>
        </FlexRow>
      )}
    </PaginateContainer>
  )
}
